import React from 'react';
import {
  compose,
  setDisplayName,
} from 'recompose';
import reactCSS from 'reactcss';
import Panel from '@ux/panel';
import { Display } from '@ux/typeface';
import { headingL } from '@ux/type-size';
import Button, { Kind, Against } from '@ux/button';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@ux/style-utils';
import cssSides, { Side } from '@team-griffin/css-sides';
import { withBreakpoints } from '@ux/responsive';
import { gu2px } from '@ux/theme-utils';
import * as r from 'ramda';

const stylesheet = ({
  theme,
  isMinSm,
  isMinMd,
  isMinLg,
}) => {
  const {
    palette,
    spacing,
    typography,
  } = theme;

  return reactCSS({
    default: {
      panel: {
        backgroundColor: palette.primary,
        color: palette.primaryContrast,
        ...cssSides('padding', Side.Y, gu2px(3, spacing)),
        ...cssSides('padding', Side.X, gu2px(4, spacing)),
        textAlign: 'center',
      },
      title: {
        marginBottom: gu2px(2, spacing),
        marginTop: 0,
        ...headingL(typography),
        fontWeight: 'normal',
      },
    },

    isMinSm: {
      panel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'left',
      },
      title: {
        marginBottom: 0,
        marginRight: gu2px(3, spacing),
      },
    },

    isMinMd: {
      panel: {
        ...cssSides('padding', Side.X, gu2px(4, spacing)),
      },
    },
  }, [
    { isMinSm },
    { isMinMd },
    { isMinLg },
  ]);
};

export const PureAddedToBasket = ({
  theme,
  fqdn,
  styles,
  isMinSm,
  onViewBasketClick,
}) => (
  <div>
    <Panel
      theme={theme}
      style={styles.panel}
      borderless={true}
    >
      <Display
        theme={theme}
        component="h1"
        style={styles.title}
      >
        <FormattedMessage
          id="dst.negotiate.addedToBasket"
          values={{
            fqdn: (
              <strong>{fqdn}</strong>
            ),
          }}
        />
      </Display>
      <Button
        onClick={onViewBasketClick}
        theme={theme}
        kind={Kind.PRIMARY}
        against={Against.PRIMARY}
        block={r.not(isMinSm)}
      >
        <FormattedMessage id="dst.negotiate.checkout"/>
      </Button>
    </Panel>
  </div>
);

export const enhance = compose(
  setDisplayName('AfternicAddedToBasket'),
  withBreakpoints,
  withStyles(stylesheet),
);

export default enhance(PureAddedToBasket);
